import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Grid,
  GridColumn,
  GridNoRecords
} from '@progress/kendo-react-grid'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery
} from '@material-ui/core'
import { Traslates, SimpleLoading } from '../../pures'
import './grid-document-tracking.css'
import { useState } from 'react'
import { ButtonHLPure } from '../../pures'

const signerCellHeader = (props) => {
  const stylesSpanCellHeader = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: '#123513',
    fontSize: '14px',
    fontFamily: 'Quicksand, sans-serif'
  };
  return (
    <span style={stylesSpanCellHeader} onClick={props.onClick}>
      {props.title}
    </span>
  )
}

const signerCellBody = (propsCell) => {
  const stylesCell = {
    paddingLeft: '16px',
    fontSize: '16px',
    fontFamily: 'Quicksand, sans-serif',
    color: '#333'
  };
  return <td style={stylesCell}>{propsCell.dataItem.dateAndHour}</td>
};

const GridDocumentTrackingPureGeneralHeaderStyle = (props) => {
  const gridColumnGeneralStyle = {
    fontSize: '14px',
    color: '#123513',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Quicksand, sans-serif'
  };
  return <span style={gridColumnGeneralStyle}>{props.title}</span>
};

const GridDocumentTrackingPure = (props) => {
  const { t } = useTranslation()

  const {
    events,
    total,
    filter,
    group,
    skip,
    take,
    sort,
    loading,
    onCommentClick,
    dataStateChange,
    onViewDocument,
    digitalVaultFileId,
    documentKey,
    isFinalized
  } = props

  const resultData = {
    data: events,
    total
  };

  const otherProps = {
    filter: filter ? filter : undefined,
    group: group ? group : undefined,
    sort: sort ? sort : [],
    skip,
    take
  };
  const iconComment = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}microservices/MiFirma/assets/inbox/eventLogs/icon_message_eventlog.svg`
  const showOnlyActions = useMediaQuery('(max-width: 950px)')

  const [selectedItem, setSelectedItem] = useState(null)
  const [isModalOpen, setModalOpen] = useState(false)

  const openModal = (item) => {
    setSelectedItem(item)
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  const gridLabelNorecordsStyles = {
    color: '#828282',
    fontSize: '15px',
    fontWeight: 500
  };

  return (
    <div className='grid-events-document-tracking'>
      {loading ? (
        <SimpleLoading />
      ) : (
        <Traslates>
          {!showOnlyActions ? (
            <Grid
              className='request-detail-event'
              data={resultData}
              {...otherProps}
              sortable={true}
              resizable={true}
              reorderable={true}
              pageable={{
                info: false,
                buttonCount: 5,
                type: 'numeric',
                previousNext: true
              }}
              onDataStateChange={dataStateChange}
            >
              <GridColumn
                title={t('gridDocumentTracking.dateAndHour')}
                width='auto'
                headerCell={signerCellHeader}
                cell={signerCellBody}
              />
              <GridColumn
                field='eventBinnacle.eventBinnacleType.name'
                title={t('gridDocumentTracking.actions')}
                width='auto'
                sortable={false}
                headerCell={GridDocumentTrackingPureGeneralHeaderStyle}
                cell={(propsCell) => {
                  const dataItem = propsCell.dataItem
                  let isCurrentStep = (dataItem.eventBinnacle && dataItem.eventBinnacle.actualProcess && !props.isCanceled && !props.isFinalized) ? true : false
                  let isCanceled = false
                  let isFinalized = false

                  if (props.isFinalized && dataItem.eventBinnacle && dataItem.eventBinnacle.isFinalized) {
                    isCurrentStep = false
                    isCanceled = false
                    isFinalized = true
                  }

                  if (props.isCanceled && dataItem.eventBinnacle && dataItem.eventBinnacle.isCanceled) {
                    isCurrentStep = false
                    isCanceled = true
                    isFinalized = false
                  }


                  return (
                    <td>
                      <div className='document-tracking-actual-process-title'>
                        {isCurrentStep && !isCanceled && !isFinalized && (
                          <span className='document-tracking-actual-process-cell'>
                            {t('documentTracking.pending')}
                          </span>
                        )}
                        {isCanceled && (
                          <span className='document-tracking-actual-process-cell'>
                            {t('documentTracking.cancelled')}
                          </span>
                        )}
                        {isFinalized && (
                          <span className='document-tracking-actual-process-cell'>
                            {t('documentTracking.finalized')}
                          </span>
                        )}
                        <span>
                          {t(`eventTypes.${dataItem.eventBinnacle?.eventBinnacleType?.translationKey}`, {
                            defaultValue: dataItem.eventBinnacle?.eventBinnacleType?.name || ''
                          })}
                        </span>
                      </div>
                    </td>
                  )
                }}
              />
              <GridColumn
                title={t('gridDocumentTracking.user')}
                width='auto'
                sortable={false}
                headerCell={GridDocumentTrackingPureGeneralHeaderStyle}
                cell={(propsCell) => {
                  const description = propsCell.dataItem.cancellationReason
                  return (
                    <td>
                      {propsCell.dataItem.nameSigner}
                      {description && (
                        <span
                          title='Ver descripción'
                          onClick={() => onCommentClick?.(description)}
                          className='user-comment-icon'
                        >
                          <img
                            src={iconComment}
                            alt='icono de comentario'
                          />
                        </span>
                      )}
                    </td>
                  )
                }}
              />
              <GridNoRecords>
                <p style={gridLabelNorecordsStyles}>
                  {t('gridDocumentTracking.noDataToShow')}
                </p>
              </GridNoRecords>
            </Grid>
          ) : (
            <div className='mobile-event-list'>
              {events.map((event, index) => (
                <div
                  key={index}
                  className='mobile-event-item'
                  onClick={() => openModal(event)}
                >
                  <i className='k-icon k-i-more-vertical'></i>
                  <span>
                    {event.eventBinnacle?.eventBinnacleType?.name || 'Acción'}
                  </span>
                </div>
              ))}
            </div>
          )}

          <Dialog open={isModalOpen} onClose={closeModal}>
            <DialogTitle className='dialog-document-tracking-title'>
              {t('documentTracking.details')}
            </DialogTitle>

            <DialogContent>
              {selectedItem && (
                <div className='dialog-document-tracking-content-text'>
                  <p>
                    <strong>{t('gridDocumentTracking.dateAndHour')}:</strong>{' '}
                    {selectedItem.dateAndHour}
                  </p>
                  <p>
                    <strong>{t('gridDocumentTracking.actions')}:</strong>{' '}
                    {selectedItem.eventBinnacle?.eventBinnacleType?.name}
                  </p>
                  <p>
                    <strong>{t('gridDocumentTracking.user')}:</strong>{' '}
                    {selectedItem.nameSigner}
                  </p>
                  {selectedItem.cancelReason && (
                    <p>
                      <strong>{t('documentTracking.cancelledReason')}:</strong>{' '}
                      {selectedItem.cancelReason}
                    </p>
                  )}
                  {selectedItem?.eventBinnacle?.actualProcess && (
                    <p>
                      <strong>{t('documentTracking.actualProcess')}:</strong>{' '}
                      <span className='document-tracking-actual-process-cell'>
                        {t('documentTracking.pending')}
                      </span>
                    </p>
                  )}
                </div>
              )}
            </DialogContent>

            <DialogActions className='dialog-document-tracking-actions'>
              <ButtonHLPure
                onClickBtn={closeModal}
                nameBtn={t('button.close')}
              />
              <ButtonHLPure
                onClickBtn={closeModal}
                primary={true}
                nameBtn={t('button.accept')}
              />
            </DialogActions>
          </Dialog>
        </Traslates>
      )}
    </div>
  );
};

export default GridDocumentTrackingPure;
